import { Component, inject } from '@angular/core';
import { NetworkErrorService } from '../../../core/services/network-error.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-network-error',
  imports: [TranslateModule],
  template: `
    @if(networkService.hasNetworkError()) {
    <div
      class="bg-[#EFF5FD] fixed top-0 left-0 w-full h-full  z-1000 flex justify-center items-center gap-3"
    >
      <div
        class="bg-white rounded-2xl p-10 flex flex-col justify-center items-center gap-3 text-center"
      >
        <img src="icons/wifi.svg" alt="wifi-no-internet" class="w-14 h-14" />
        <h3 class="text-secondary font-medium text-2xl">
          {{ 'Errors.No_Internet' | translate }}
        </h3>
        <p class="text-[#6B7280] font-medium mb-0 w-95">
          {{ 'Errors.Network_Message' | translate }}
        </p>
        <button
          (click)="retry()"
          class="bg-brand px-6 mx-auto w-full md:w-fit py-3 text-white text-lg font-medium rounded-2xl hover:bg-[#1d8ed3] transition-colors duration-300"
        >
          {{ 'Errors.Try_Again' | translate }}
        </button>
      </div>
    </div>
    }
  `,
})
export class NetworkErrorComponent {
  public networkService = inject(NetworkErrorService);

  retry() {
    this.networkService.hideError();
    window.location.reload();
  }
}
